<template>
  <div>
    <b-card v-if="isCard">
      <vue-apex-charts
        v-if="series[0].data.length > 0"
        type="line"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
    <div v-else>
      <vue-apex-charts
        v-if="series[0].data.length > 0"
        type="line"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'BasicAreaCharts',
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    isCard: {
      type: Boolean,
      default: true,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    labelsData: {
      type: Array,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ['#bf0b0f', '#0b74bf'],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth',
        },
        title: {
          text: '',
          align: 'left',
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: [],
          title: {
            text: 'Aylar',
          },
        },
        yaxis: {
          title: {
            text: 'Görüşmeler',
          },
          // min: 0,
          // max: 5000,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    labelsData: 'setData',
    titleText: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.labelsData
      this.chartOptions.title.text = this.titleText
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
